import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/auth/components/auth/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/[locale]/auth/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.20_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.101.0/node_modules/next/dist/client/app-dir/link.js");
